<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Message Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editMessage">Edit Message</button>
                </div>
            </div>
            <div class="table-responsive" v-if="message">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{message.greetingId}}</td>
                    </tr>
                    <tr>
                        <th>Message</th>
                        <td>{{message.greeting}}</td>
                    </tr>
                   <tr>
                     <th>Corporations</th>
                     <td>{{message.corporationName}}</td>
                   </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="message.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewMessage',
        components: {
            LTable,
        },
        created (){
            console.log('inside view message')
        this.$store.dispatch('GETSELECTEDMESSAGE', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedMessage)
            this.message = this.selectedMessage;
        })
    },
    data () {
        return {
          message: {}
        }
    },
    methods: {
        editMessage(){
            this.$router.push({ name: 'EditMessage', params: { id: this.message.greetingId}})
        },
    },
    computed: {...mapGetters([
        'selectedMessage'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Messages/MessageDetails.vue